import type { Breakpoints, Size } from '@amp/web-app-components/src/types';

export type MediaConditions = { [key in Size]?: string };

type BreakpointOptions = { offset?: number };

// eslint-disable-next-line import/prefer-default-export
export function getMediaConditions<T extends string | number | symbol = Size>(
    breakpoints: Breakpoints<T>,
    options?: BreakpointOptions,
): MediaConditions {
    const queries = {};

    const viewportOrder = {
        xsmall: 0,
        small: 1,
        medium: 2,
        large: 3,
        xlarge: 4,
    };

    const offset = options?.offset ?? 0;

    const viewportSizes = Object.keys(breakpoints).sort(
        (a, b) => viewportOrder[a] - viewportOrder[b],
    );
    // TODO: rdar://76402413 (Convert imperative reduce pattern
    // to functionalwith Object.fromEntries once on Node 12)
    viewportSizes.reduce((acc, viewport) => {
        const { min, max } = breakpoints[viewport];

        if (min && !max) {
            acc[viewport] = `(min-width:${min + offset}px)`;
        } else if (!min && max) {
            acc[viewport] = `(max-width:${max + offset}px)`;
        } else if (min && max) {
            acc[viewport] = `(min-width:${min + offset}px) and (max-width:${
                max + offset
            }px)`;
        }
        return acc;
    }, queries);

    return queries;
}
